/* eslint-disable react-hooks/rules-of-hooks */
import moment from "moment";
import { useState } from "react";
import DataTable from "react-data-table-component";
import { useTranslation } from "react-i18next";
import { Badge, Button, Input, TextInput } from "@mantine/core";
import { ChevronRight, PlusCircle, Search } from "react-feather";
import { useQuery } from "react-query";
import axios from "axios";
import { API } from "../../static";
import { useNavigate } from "react-router-dom";

const AdminsTable = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [admins, setAdmins] = useState();

  const navigate = useNavigate();

  const getAdmins = () => {
    return useQuery(
      "getAdmins",
      async () => {
        return await axios.post(`${API}/admin-api/V1/admin/list`);
      },
      {
        onSuccess: async (data, variables, context) => {
          setAdmins(data.data);
        },
      }
    );
  };

  const { isLoading } = getAdmins();

  const { t } = useTranslation();

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase()); // Search should be case-insensitive
  };

  const filterData = (data) => {
    return data?.filter((row) => {
      const searchTerm = searchQuery.toLowerCase();
      const firstName = row.firstName.toLowerCase();
      const lastName = row.lastName.toLowerCase();
      const username = row.username.toLowerCase();
      const email = row.email.toLowerCase();
      return (
        firstName.includes(searchTerm) ||
        lastName.includes(searchTerm) ||
        username.includes(searchTerm) ||
        email.includes(searchTerm)
      );
    });
  };

  const filteredData = filterData(admins);

  const columns = [
    {
      name: "#",
      selector: (row, key) => key + 1,
      width: "40px",
    },
    {
      name: t("FullName"),
      selector: (row) => `${row.firstName} ${row.lastName}`,
    },
    {
      name: "Username",
      selector: (row) => row.username,
    },
    {
      name: "Status",
      selector: (row) =>
        row.active ? (
          <Badge color="green">Active</Badge>
        ) : (
          <Badge color="red">Inactive</Badge>
        ),
    },
    {
      name: t("Email"),
      selector: (row) => row.email,
    },
    {
      name: "Creation date",
      selector: (row) => moment(row.createdAt).format("DD MMMM YYYY"),
    },
    {
      name: "Actions",
      selector: (row) => (
        <Button
          onClick={() => navigate(`/administrator/details/${row._id}`)}
          variant="outline"
          rightSection={<ChevronRight size={15} />}
        >
          Details
        </Button>
      ),
    },
  ];

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <Input
          leftSection={<Search size={16} />}
          placeholder={t("SearchPlaceholder")}
          className="mb-3 w-50"
          value={searchQuery}
          onChange={handleSearchChange}
        />
        <Button
          onClick={() => navigate("/administrator/new")}
          leftSection={<PlusCircle size={16} />}
        >
          Create new administrator
        </Button>
      </div>
      <DataTable
        columns={columns}
        data={filteredData}
        direction="auto"
        fixedHeaderScrollHeight="300px"
        highlightOnHover
        pagination
        responsive
        striped
        subHeaderAlign="right"
        subHeaderWrap
      />
    </>
  );
};

export default AdminsTable;
